module.exports = "//public.zight.com/packs/media/images/conversation-5585e9c30465cebe4fcb440364a092bb.svg";